import type { RouteObject } from "react-router-dom";

import { Protected } from "@dzambalaorg/common-pages";
import { Profile, ServiceType } from "@framework/shared";

import { Merchant } from "./merchant";
import { RatePlan } from "./rate-plan";
import { FeatureFlagsSettings } from "./feature-flags";

export const infrastructureRoutes: Array<RouteObject> = [
  {
    path: "/profile",
    element: <Protected />,
    children: [
      { index: true, element: <Profile service={ServiceType.ADMIN} /> },
      { path: "/profile/:tab", element: <Profile service={ServiceType.ADMIN} /> },
    ],
  },
  {
    path: "/merchant",
    element: <Protected />,
    children: [
      { index: true, element: <Merchant /> },
      { path: "/merchant/:tab", element: <Merchant /> },
    ],
  },
  {
    path: "/rate-plans",
    element: <Protected />,
    children: [{ index: true, element: <RatePlan /> }],
  },
  {
    path: "/featureFlags",
    element: <Protected />,
    children: [{ index: true, element: <FeatureFlagsSettings /> }],
  },
];
